module.exports = __webpack_public_path__ + "static/media/right-arrow.f346b6c3.svg";